import React from "react";
import { connect } from "react-redux";
import { clearInfo } from "../../redux/actions/Errors";
import CloseButton from "../../components/CloseButton/CloseButton";
import "./Info.css";

/**
 * Site wide message sub component
 * Using the message state
 *
 * @param clear
 * @param message
 * @returns {*}
 * @constructor
 */
const Info = ({ clear, message }) => {
  if (message) {
    return (
      <div className="PageInfo">
        <p className="PageInfo__Message">{message.message}</p>
        <small className="PageInfo__Hint">{message.hint}</small>
        <CloseButton onClick={clear} />
      </div>
    );
  }

  return null;
};

const mapStateToProps = ({ messages }) => ({
  message: messages.info
});

const mapDispatchToProps = dispatch => {
  return {
    clear: () => {
      dispatch(clearInfo());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Info);



// WEBPACK FOOTER //
// ./src/containers/App/Info.js